const getEnvVars = (origin) => {
  const subdomain = origin.split('//')[1].split('.')[0];
  if (subdomain === 'rbac-app') {
    return {
      AUTH0_CLIENT_ID: '9O89YG8psX4otL4MhME7fcBYeW1ISVqo',
      DOMAIN: 'secure.idemtools.com',
      ENV: 'production',
      API_URL: 'https://rbac-service.idemtools.com',
      RBAC_AUD: 'https://rbac-service.idemtools.com',
    };
  }
  if (subdomain === 'rbac-app-stage') {
    return {
      AUTH0_CLIENT_ID: 'EIBRb4DFmLgE9wXV2EfaktRJx9A1ybhd',
      DOMAIN: 'auth-stage.sandvik.com',
      ENV: 'staging',
      API_URL: 'https://sms-bridge-stage.sandvik.com/rbac',
      RBAC_AUD: 'https://sms-bridge-stage.sandvik.com/rbac',
    };
  }
  if (subdomain === 'admin-bridge') {
    return {
      AUTH0_CLIENT_ID: '7O8Ulm9g9i0HAGDzaM6zIfkOSwl1shMa',
      DOMAIN: 'auth.sandvik.com',
      ENV: 'production',
      API_URL: 'https://sms-bridge.sandvik.com/rbac',
      RBAC_AUD: 'https://sms-bridge.sandvik.com/rbac',
    };
  }
  if (subdomain === 'localhost:6002') {
    return {
      AUTH0_CLIENT_ID: 'aar3ZYl4Jg30qHsPuOSsHe58375YYoPU',
      DOMAIN: 'dev-idem.eu.auth0.com',
      ENV: 'development',
      API_URL: 'http://host.docker.internal:3001',
      RBAC_AUD: 'https://dev-rbac-service.idemtools.com',
    };
  }
  return {
    AUTH0_CLIENT_ID: 'aar3ZYl4Jg30qHsPuOSsHe58375YYoPU',
    DOMAIN: 'dev-idem.eu.auth0.com',
    ENV: 'development',
    API_URL: 'https://app-rbac-dev-001.azurewebsites.net',
    RBAC_AUD: 'https://app-rbac-dev-001.azurewebsites.net',
  };
};

const { AUTH0_CLIENT_ID, DOMAIN, ENV, API_URL, RBAC_AUD } = getEnvVars(
  window.origin
);

export { DOMAIN, AUTH0_CLIENT_ID, ENV, API_URL, RBAC_AUD };
